import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray, defineProperty as _defineProperty, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import Styles from './AidQuestionnaire.module.scss.js';
import questionnaireIcon from './assets/questionnaire_icon.svg.js';
import React, { forwardRef, useState, useRef, useImperativeHandle, useEffect } from 'react';
import { getQuestionnaire, saveQuestionnaire } from './api.js';
import classNames from 'classnames';
import Toast from '../AidToast/index.js';
import { getCity } from '../../utils/ikeaSDK.js';

var questionnaireCache = new Map();
function Questionnaire(props, ref) {
  props.title;
    var _props$pageName = props.pageName,
    pageName = _props$pageName === void 0 ? '' : _props$pageName,
    _props$prdline = props.prdline,
    prdline = _props$prdline === void 0 ? 'pax' : _props$prdline,
    _props$featureName = props.featureName,
    featureName = _props$featureName === void 0 ? 'exit' : _props$featureName,
    _props$prefix = props.prefix,
    prefix = _props$prefix === void 0 ? '/api' : _props$prefix,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? "在此填写" : _props$placeholder,
    onChange = props.onChange;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    allOptions = _useState2[0],
    setAllOptions = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isInputShow = _useState4[0],
    setIsInputShow = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    questionnaire = _useState6[0],
    setQuestionnaire = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    remark = _useState8[0],
    setRemark = _useState8[1];
  var textareaRef = useRef(null);
  var getOptions = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _questionnaire, _surveyOptions;
      var key, questionnaire, _result$data, result, surveyOptions;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              key = "".concat(featureName, "-").concat(pageName);
              if (!questionnaireCache.get(key)) {
                _context.next = 5;
                break;
              }
              questionnaire = questionnaireCache.get(key);
              _context.next = 10;
              break;
            case 5:
              _context.next = 7;
              return getQuestionnaire({
                featureName: featureName,
                prdline: prdline,
                pageName: pageName
              }, prefix);
            case 7:
              result = _context.sent;
              questionnaire = (((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.questionnaireSubjects) || [])[0] || result.data || result;
              questionnaireCache.set(key, questionnaire);
            case 10:
              setQuestionnaire(questionnaire);
              surveyOptions = (((_questionnaire = questionnaire) === null || _questionnaire === void 0 ? void 0 : _questionnaire.options) || []).map(function (item) {
                return {
                  source: item,
                  checked: false
                };
              });
              surveyOptions = (_surveyOptions = surveyOptions) === null || _surveyOptions === void 0 ? void 0 : _surveyOptions.sort(function (a, b) {
                if (needInputOption(a)) {
                  return 1;
                }
                if (needInputOption(b)) {
                  return 0;
                }
                return Math.random() - 0.5;
              });
              surveyOptions && setAllOptions(surveyOptions);
            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function getOptions() {
      return _ref.apply(this, arguments);
    };
  }();
  var saveOptions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(cb) {
      var cityInfo, selected;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getCity();
            case 2:
              _context2.t0 = _context2.sent;
              if (_context2.t0) {
                _context2.next = 5;
                break;
              }
              _context2.t0 = {};
            case 5:
              cityInfo = _context2.t0;
              if (questionnaire) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return");
            case 8:
              selected = allOptions.reduce(function (result, current) {
                if (current.checked) {
                  result.push(current.source);
                }
                return result;
              }, []);
              _context2.next = 11;
              return cb(questionnaire.options, selected, remark);
            case 11:
              if (!(selected.length === 0)) {
                _context2.next = 13;
                break;
              }
              return _context2.abrupt("return");
            case 13:
              _context2.next = 15;
              return saveQuestionnaire({
                deviceId: '',
                questionnaireSubjectId: questionnaire.id,
                selected: selected,
                remark: remark,
                prdline: prdline,
                zipcode: cityInfo.zipcode || ''
              }, prefix);
            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function saveOptions(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  useImperativeHandle(ref, function () {
    return {
      confirm: function () {
        var _confirm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(cb) {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return saveOptions(cb);
                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        function confirm(_x2) {
          return _confirm.apply(this, arguments);
        }
        return confirm;
      }()
    };
  }, [questionnaire, allOptions, remark]);
  useEffect(function () {
    getOptions();
  }, [featureName, pageName]);
  useEffect(function () {
    if (!questionnaire || !onChange) return;
    var selected = allOptions.reduce(function (result, current) {
      if (current.checked) {
        result.push(current.source);
      }
      return result;
    }, []);
    onChange && onChange(questionnaire.options, selected, remark);
  }, [allOptions, remark]);
  var handleChange = function handleChange(e) {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = "".concat(e.target.scrollHeight + 2, "px");
    }
    if (e.target.value.length >= 50) {
      Toast.show('最多输入50字');
    }
    setRemark(e.target.value);
  };
  if (allOptions.length === 0) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  function needInputOption(item) {
    return item.source.includes('其他') || item.source.includes('填写');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: Styles.surveyBox
  }, /*#__PURE__*/React.createElement("p", {
    className: Styles.desc
  }, /*#__PURE__*/React.createElement("img", {
    src: questionnaireIcon,
    alt: ""
  }), "\u8BBE\u8BA1\u5DE5\u5177\u95EE\u5377\u8C03\u7814"), /*#__PURE__*/React.createElement("h3", null, questionnaire.subjectName), /*#__PURE__*/React.createElement("div", {
    className: Styles.options
  }, allOptions.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.source,
      onClick: function onClick() {
        if (questionnaire.subjectType === 1) {
          var preChecked = item.checked;
          allOptions.forEach(function (option) {
            return option.checked = false;
          });
          item.checked = preChecked ? false : true;
          setAllOptions(_toConsumableArray(allOptions));
          if (needInputOption(item) && item.checked) {
            setIsInputShow(true);
          } else {
            setIsInputShow(false);
          }
          setRemark('');
        } else {
          item.checked = !item.checked;
          setAllOptions(_toConsumableArray(allOptions));
          if (needInputOption(item)) {
            setIsInputShow(!isInputShow);
            setRemark('');
          }
          if (!isInputShow) {
            setRemark('');
          }
        }
      },
      className: classNames(Styles.option, _defineProperty({}, Styles.active, item.checked))
    }, item.source);
  })), isInputShow && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("textarea", {
    placeholder: placeholder,
    ref: textareaRef,
    rows: 1,
    className: Styles.inputer,
    maxLength: 50,
    value: remark,
    onChange: handleChange
  })));
}
var AidQuestionnaire = /*#__PURE__*/forwardRef(Questionnaire);

export { AidQuestionnaire as default };
